import { useState } from 'react'
import { ProjectsService, UploadFileType } from '../services/ProjectsService'
import { acceptedImageFormat } from '../models/photo'

export const useUploadPhoto = ({
    uploadedImageList,
    setUploadedImageList,
    setModalLoading,
    onFormatError,
    onSizeError,
    onUploadDone,
    setEditLoading = (value: boolean) => null,
    setSelectedImage = (value: string) => null,
}) => {
    const [imagePosition, setImagePosition] = useState(0)
    const [dialogUploadPhotoVisible, setDialogUploadPhotoVisible] = useState<boolean>(false)

    const onEditImage = (blob: Blob, title: string, id: string, position: number) => {
        setEditLoading(true)
        const file = new File([blob], title)
        const reader = new FileReader()
        reader.onload = async (evt) => {
            try {
                await ProjectsService.editFile(
                    evt.target.result,
                    UploadFileType.PHOTO,
                    file.name,
                    file.type,
                    id
                ).finally(() => {
                    setEditLoading(false)
                    setSelectedImage(reader.result.toString())
                    const newList = [...uploadedImageList]
                    newList[position - 1] = {
                        name: file.name,
                        url: reader.result.toString(),
                        attachmentId: id,
                    }
                    setUploadedImageList(newList)
                })
            } catch (err) {}
        }
        reader.readAsDataURL(file)
    }

    const uploadImageList = ({
        files,
        list,
        editImagePosition,
    }: {
        files: any[]
        list?
        editImagePosition?
    }) => {
        list = list || []
        const localImagePostion = imagePosition || editImagePosition
        setModalLoading(true)
        const file = files[0]
        const newFiles = [...files]
        newFiles.shift()
        const reader = new FileReader()
        reader.onload = async (evt) => {
            try {
                await ProjectsService.UploadFile(
                    evt.target?.result,
                    UploadFileType.PHOTO,
                    file.name,
                    file.type
                ).then((res) => {
                    list = [
                        ...list,
                        {
                            name: file.name,
                            url: file.url,
                            attachmentId: res.data.id,
                        },
                    ]
                    if (newFiles.length > 0) {
                        uploadImageList({ files: newFiles, list })
                        return
                    }
                    if (!localImagePostion) {
                        setUploadedImageList((uploadedImageList) => [...uploadedImageList, ...list])
                    } else {
                        const newList = [...uploadedImageList]
                        newList[localImagePostion - 1] = {
                            name: file.name,
                            url: file.url,
                            attachmentId: res.data.id,
                        }
                        setUploadedImageList(newList)
                    }
                    setModalLoading(false)
                    setDialogUploadPhotoVisible(false)
                    onUploadDone()
                })
            } catch (err) {}
        }
        reader.readAsDataURL(file.fileObj)
    }

    const onFileChange = function (e) {
        e.preventDefault()
        if (!Object.values(e.target.files).length) return
        let formatError = false
        let sizeError = false
        Object.values(e.target.files).forEach((f: any) => {
            formatError = formatError || acceptedImageFormat.indexOf(f.name.split('.').pop()) === -1
            sizeError = sizeError || f.size > 20971520
        })
        if (formatError) {
            onFormatError()
            return
        }
        if (sizeError) {
            onSizeError()
            return
        }
        if (!imagePosition) {
            // setSlide(0)
            const newFiles = Object.values(e.target.files).map((f: any) => ({
                name: f.name,
                url: URL.createObjectURL(f),
                fileObj: f,
            }))
            uploadImageList({ files: newFiles })
        } else {
            uploadImageList({
                files: [
                    {
                        url: URL.createObjectURL(e.target.files[0]),
                        name: e.target.files[0].name,
                        fileObj: e.target.files[0],
                    },
                ],
            })
        }
        setImagePosition(0)
    }

    return {
        imagePosition,
        setImagePosition,
        dialogUploadPhotoVisible,
        setDialogUploadPhotoVisible,
        onFileChange,
        uploadImageList,
        onEditImage,
    }
}
